// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"87d2b815","226":"6f8f6143","419":"7a2a4369","453":"84b72db2","567":"1dfe0a7e","632":"140b0230","638":"41a1d4b7","995":"847108f0"}[chunkId] + ".chunk.js";
};